import { useState, useEffect } from "react";
import { Picker } from 'antd-mobile'
import SimulationInput from "@src/component/SimulationInput";
type Pick = {
  columns: Array<any>
  onChange?: (value: string | number) => void
  onChangeData?: (value: string | number, opt?: any) => void
  value?: string | number
  id?: string
  placeholder?: string
  disabled?: boolean
}
export default function (props: Pick) {
  const [visible, setVisible] = useState<boolean>(false)
  const [value, setValue] = useState<string | number>('')
  const triggerValue = (changedValue: string | number) => {
    props.onChange?.(changedValue)
  }
  useEffect(()=>{
    const find = props?.columns?.find((res: any) => res.value == props.value)
    if (find?.label) {
      setValue(find?.label)
    } else {
      setValue('')
    }
  },[props.value, props.columns])

  return <div style={{height: '100%'}}>
    <div style={{height: '100%'}} onClick={() => {props.disabled?null:setVisible(true) }}>
      <SimulationInput id={props.id} placeholder={props.placeholder || '请选择'} value={`${value}`}></SimulationInput>
    </div>
    <Picker style={{
          '--title-font-size': '14px',
          '--header-button-font-size': '14px',
          '--item-font-size': '14px',
          '--item-height': '40px',
        }} columns={[props.columns]} visible={visible} onConfirm={(e) => {
      const find = props.columns.find((res: any) => res.value == e[0])
      setValue(find.label)
      triggerValue(find.value)
      props.onChangeData&&props.onChangeData(find.value, find)
    }} onClose={() => { setVisible(false) }} />
  </div>
}